import { memo } from "react";
import PropTypes from "prop-types";
import ProgressiveImg from "app/pages/.shared/ProgressiveImg";

const IMG_SIZES = {
	large: { width: 1847 },
	xlarge: { width: 1847 },
};

const HomeBackground = ({ image, thumbnail }) => {
	return (
		<ProgressiveImg
			sizes={IMG_SIZES}
			src={image}
			thumbnail={thumbnail}
			backgroundPosition="right"
			cover
			disableLazyLoad
			fetchPriority="high"
		/>
	);
};

HomeBackground.propTypes = {
	image: PropTypes.string,
	thumbnail: PropTypes.string,
};

export default memo(HomeBackground);
